// postervideo.js - JS to handle video posters, because iOS is wonky
// Copyright (C) 2020 Saxton Technical Event Solutions

AFRAME.registerComponent('postervideo', {
  schema: {
    src: {type: 'string'},
    linkHeight: {default: 3.00},
    website: {default: 'https://www.saxton.tech'},
    enabled: {default: true},
  },

  init: function (data) {
  },

  update: function () {
    // console.log("postervideo update   this.data:", this.data);

    if (this.data.src) {
      const id = 'z' + Math.round(Math.random()*Number.MAX_SAFE_INTEGER).toString(36);

      const src = this.data.src;
      // console.log('postervideo:', id, src);

      const asset = document.createElement('video');
      asset.id = id;
      asset.src = src;
      asset.loop = true;
      asset.muted = true;
      asset.crossOrigin = "anonymous";
      asset.setAttribute('webkit-playsinline', 'webkit-playsinline');
      asset.setAttribute('playsinline', 'playsinline');
      document.querySelector('a-assets').append(asset);

      this.el.setAttribute('material', {shader: 'flat', src: '#'+id});
      this.el.setAttribute('event-set__leave', {'_event': 'mouseleave', 'material.src': '#'+id});
    }

    this.el.addEventListener('click', evt => {
      // console.log("postervideo click:", evt.detail.intersection.point);
      if (evt.detail.intersection.point.y > this.data.linkHeight) {
        window.open(this.data.website);
      }
    });
  },
});
